import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

type FormField = {
  id: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  maxlength?: number;
  type: 'text' | 'select' | 'group' | 'label' | 'RefImages' | 'instruction' | 'cardNumber' | 'dateInput';
  options?: any[];
  errorMessage?: string;
  fields?: FormField[];
  className?: string
};

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['../add-edit-payment-method.component.css']
})

export class Card {
  @Input() selectedTab: any;
  @Input() ban: any;
  @Input() paymentMethodData: any;
  @Input() apiResponseError: any;

  @Output() updatePaymentMethod = new EventEmitter<any>();
  @Output() addPaymentMethod = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();

  public paymentFormCard: FormGroup;
  paymentMethodOptions: any = [{ value: 'creditcard', label: 'Credit/Debit Card' }]
  stateOptions: any = [
    { value: 'AL', label: 'AL' },
    { value: 'AK', label: 'AK' },
    { value: 'AZ', label: 'AZ' },
    { value: 'AR', label: 'AR' },
    { value: 'CA', label: 'CA' },
    { value: 'CO', label: 'CO' },
    { value: 'CT', label: 'CT' },
    { value: 'DE', label: 'DE' },
    { value: 'FL', label: 'FL' },
    { value: 'GA', label: 'GA' },
    { value: 'HI', label: 'HI' },
    { value: 'ID', label: 'ID' },
    { value: 'IL', label: 'IL' },
    { value: 'IN', label: 'IN' },
    { value: 'IA', label: 'IA' },
    { value: 'KS', label: 'KS' },
    { value: 'KY', label: 'KY' },
    { value: 'LA', label: 'LA' },
    { value: 'ME', label: 'ME' },
    { value: 'MD', label: 'MD' },
    { value: 'MA', label: 'MA' },
    { value: 'MI', label: 'MI' },
    { value: 'MN', label: 'MN' },
    { value: 'MS', label: 'MS' },
    { value: 'MO', label: 'MO' },
    { value: 'MT', label: 'MT' },
    { value: 'NE', label: 'NE' },
    { value: 'NV', label: 'NV' },
    { value: 'NH', label: 'NH' },
    { value: 'NJ', label: 'NJ' },
    { value: 'NM', label: 'NM' },
    { value: 'NY', label: 'NY' },
    { value: 'NC', label: 'NC' },
    { value: 'ND', label: 'ND' },
    { value: 'OH', label: 'OH' },
    { value: 'OK', label: 'OK' },
    { value: 'OR', label: 'OR' },
    { value: 'PA', label: 'PA' },
    { value: 'RI', label: 'RI' },
    { value: 'SC', label: 'SC' },
    { value: 'SD', label: 'SD' },
    { value: 'TN', label: 'TN' },
    { value: 'TX', label: 'TX' },
    { value: 'UT', label: 'UT' },
    { value: 'VT', label: 'VT' },
    { value: 'VA', label: 'VA' },
    { value: 'WA', label: 'WA' },
    { value: 'WV', label: 'WV' },
    { value: 'WI', label: 'WI' },
    { value: 'WY', label: 'WY' }
  ]

  public encryptedData: any = "";

  cardFormFields: FormField[] = [
    {
      id: 'cardHolderName',
      label: 'Cardholder Name',
      placeholder: 'Enter the name on your card',
      required: true,
      errorMessage: 'Invalid card holder name.',
      type: 'text'
    },
    {
      id: 'cardNumber',
      label: 'Card Number',
      placeholder: 'Enter card number',
      required: true,
      maxlength: 19,
      errorMessage: 'Invalid card number.',
      type: 'cardNumber'
    },
    {
      id: 'cardImages',
      label: '',
      type: 'RefImages'
    },
    {
      id: 'cardDetails',
      label: 'Card Details',
      type: 'group',
      fields: [
        {
          id: 'expirationDate',
          label: 'Expiration Date',
          required: true,
          placeholder: 'Enter MM/YY',
          maxlength: 5,
          type: 'dateInput',
          errorMessage: 'Invalid expiration date.'
        },
        {
          id: 'cvv',
          label: 'CVV',
          required: true,
          placeholder: 'Enter CVV',
          maxlength: 3,
          type: 'text',
          errorMessage: 'Invalid CVV.'
        },
        {
          id: 'zipCode',
          label: 'ZIP Code',
          placeholder: 'Enter ZIP code',
          required: true,
          maxlength: 5,
          errorMessage: 'Invalid ZIP code.',
          type: 'text'
        }
      ]
    }
  ];

  cardType: string = 'showAll';

  constructor(private formBuilder: FormBuilder, private http: HttpClient) {
    this.paymentFormCard = this.formBuilder.group({
      id: [''],
      cardHolderName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]+$')]], // Only letters and spaces allowed
      cardNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^([0-9]{4} ?){3}[0-9]{4}$'), // Exactly 16 digits
          Validators.minLength(19),
          Validators.maxLength(19)
        ]
      ],
      expirationDate: [
        '',
        [
          Validators.required,
          Validators.pattern('(0[1-9]|1[0-2])\/([0-9]{2})'), // Format MM/YY
          Validators.minLength(5),
          Validators.maxLength(5)
        ]
      ],
      cvv: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{3}$'), // Exactly 3 digits
          Validators.minLength(3),
          Validators.maxLength(3)
        ]
      ],
      streetAddress: [''],
      city: ['', [Validators.pattern('^[a-zA-Z ]+$')]], // Only letters and spaces allowed
      state: [
        '',
        [
          Validators.pattern('^[A-Z]{2}$') // Exactly 2 uppercase letters (for state code)
        ]
      ],
      zipCode: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{5}$'), // Exactly 5 digits (US ZIP code format)
          Validators.minLength(5),
          Validators.maxLength(5)
        ]
      ]
    });
  }

  get paymentMethodDetails() {
    return this.paymentMethodData;
  }

  ngOnInit() {
    const cardNumberControl = this.paymentFormCard.get('cardNumber');
    if (this.paymentMethodData.id) {
      this.patchFormValues(this.paymentMethodDetails)
      cardNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(19),
        Validators.maxLength(19),
        Validators.pattern('^[0-9* ]+$')
      ]);
    } else {
      cardNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(19),
        Validators.maxLength(19),
        Validators.pattern('^([0-9]{4} ?){3}[0-9]{4}$'),
      ]);
    }
  }

  patchFormValues(data: any) {
    if (data.paymentType == 'Card') {
      this.cardType = data.creditCardType;
      this.paymentFormCard.patchValue({
        id: data.id,
        paymentMethodType: data.type,
        cardHolderName: data.accountHolderInfo.accountHolderName,
        cardNumber: data.cardNumber.replace(/(.{4})/g, '$1 ').trim(),
        expirationDate: `${data.expirationMonth}/${data.expirationYear}`,
        cvv: data.accountHolderInfo.cvv,
        // streetAddress: data.accountHolderInfo.streetAddress,
        // city: data.accountHolderInfo.city,
        // state: data.accountHolderInfo.state,
        zipCode: data.accountHolderInfo.zipCode
      });
    }
  }

  getCardFormField(field: any) {
    return this.paymentFormCard.get(field);
  }

  getCardErrorCheck(field: any) {
    return (this.getCardFormField(field)?.invalid && (this.getCardFormField(field)?.touched || this.getCardFormField(field)?.dirty))
  }


  get isCardNumberUpdated(): boolean {
    const editedCardNumber = this.paymentFormCard.value.cardNumber;
    const receivedCardNumber = this.paymentMethodDetails.cardNumber;
    if (!editedCardNumber || !receivedCardNumber) {
      return true;
    }
    return editedCardNumber.replace(/[* ]/g, '') !== receivedCardNumber.replace(/[* ]/g, '');
  }
  async onSubmitCard() {
    if (this.paymentFormCard.valid) {
      const encryptedValue = await this.encryptData();
      let formData = {
        "id": this.paymentFormCard.value.id,
        // "street": this.paymentFormCard.value.streetAddress,
        // "city": this.paymentFormCard.value.city,
        // "state": this.paymentFormCard.value.state,
        "zip": this.paymentFormCard.value.zipCode,
        "encFields": "#field_creditCardNumber#field_cardSecurityCode#field_creditCardExpirationMonth#field_creditCardExpirationYear",
        "cardHolderName": this.paymentFormCard.value.cardHolderName,
        "paymentType": "Card",
        "creditAccount": this.ban,
        "paymentMethodKind": "creditcard",
        "encValues": encryptedValue
      }
      if (encryptedValue) {
        if (this.paymentMethodData.id) {
          this.updatePaymentMethod.emit(formData)
        }
        else {
          this.addPaymentMethod.emit(formData)
        }
      } else {
        console.error("Encryption failed, unable to call API.");
      }
    } else if (this.paymentFormCard.invalid) {
      this.paymentFormCard.markAllAsTouched();
    }
  }

  async encryptData() {
    const { expMonth, expYear } = this.separateMonthAndYear(this.paymentFormCard.value.expirationDate);

    const { cvv, cardNumber } = this.paymentFormCard.value;
    let cardNo = this.isCardNumberUpdated ? cardNumber.replace(/\s+/g, '') : ''
    const encValue = `#${cardNo}#${cvv}#${expMonth}#${expYear}`;

    const encoder = new TextEncoder();
    const data = encoder.encode(encValue);
    const publicKeyData = this.base64ToArrayBuffer(environment.encryptionKey);

    try {
      const importedPublicKey = await window.crypto.subtle.importKey(
        "spki",
        publicKeyData,
        { name: "RSA-OAEP", hash: { name: "SHA-256" } },
        false,
        ["encrypt"]
      );

      const encrypted = await window.crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        importedPublicKey,
        data
      );

      const encryptedValue = this.arrayBufferToBase64(encrypted);
      this.encryptedData = encryptedValue;
      return encryptedValue;
    } catch (error) {
      console.error(error);
      return
    }
  }

  base64ToArrayBuffer(base64: any) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  arrayBufferToBase64(buffer: any) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  separateMonthAndYear(expiryDate: any) {
    const parts = expiryDate.split('/');
    const expMonth = parts[0];
    const expYear = parseInt(parts[1], 10);
    return { expMonth, expYear };
  }

  selectDropdownValue(field: any, e: any) {
    this.paymentFormCard.get(field)!.setValue(e.label);
  }

  clearForm() {
    this.paymentFormCard.reset();
  }

  closePopup() {
    this.closeModal.emit();
  }

  onCardNumberInput(target: any): void {
    if (target) {
      const formattedValue = target.value && target.value.replace(/\D/g, '').replace(/(\d{4})/g, '$1 ').trim();
      target.value = formattedValue;
      this.paymentFormCard.get('cardNumber')?.setValue(formattedValue, { emitEvent: false });
    }
    this.getCardType();
  }

  getCardType() {
    this.cardType = this.identifyCardType(this.paymentFormCard.value.cardNumber) || 'showAll'
  }

  identifyCardType(cardNumber: any) {
    if (!cardNumber) {
      return 'showAll'
    };

    cardNumber = cardNumber.replace(/[\s-]/g, '');

    const cardPatterns = {
      VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
      MASTERCARD: /^5[1-5][0-9]{14}$/,
      DISCOVER: /^6(?:011|5[0-9]{2})[0-9]{12}$/
    };

    for (const [cardType, pattern] of Object.entries(cardPatterns)) {
      if (pattern.test(cardNumber)) {
        return cardType;
      }
    }
    return 'showAll';
  }

  formatDate(event: any): void {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    if (inputValue.length >= 3) {
      inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 4);
    }
    event.target.value = inputValue;
  }
}
